module.exports = __webpack_public_path__ + "img/glitter_8.c1878bd7.jpg";